var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasAccess)?_c('search',{attrs:{"search-type":"startups"},on:{"send-message":_vm.openChat}}):_vm._e(),_c('StartChatPopup',{ref:"startChat",attrs:{"contactsType":"ecosystem"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }